import { TextCell } from 'app/components/Table';
import { IProduct } from 'app/types/interfaces/Product';
import React from 'react';

export const POItemColumnDef = () => [
  {
    title: 'Item Name',
    dataIndex: 'productProfile',
    render: (value: IProduct) => {
      return <TextCell>{value.name}</TextCell>;
    }
  },
  {
    title: 'Item No.',
    dataIndex: 'productProfile',
    render: (value: IProduct) => {
      return <TextCell>{value.itemNo}</TextCell>;
    }
  },
  {
    title: 'Order Qty',
    dataIndex: 'orderQty',
    render: (value: string) => {
      return <TextCell>{value}</TextCell>;
    }
  },

  {
    title: 'Carton Qty',
    dataIndex: 'cartonsNo',
    render: (value: string) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Customer Name',
    dataIndex: 'clientName',
    render: (value: any) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Customer PO No.',
    dataIndex: 'clientPONo',

    render: (value: any) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Category',
    dataIndex: 'productProfile',
    render: (value: IProduct) => {
      const { categories } = value ?? {};
      return (
        <TextCell>
          {(categories || [])
            .map(({ name_en }: any) => name_en)
            .filter((value) => !!value)
            .join(', ')}
        </TextCell>
      );
    }
  },
  {
    title: 'Signed?',
    dataIndex: 'isSignSample',

    render: (value: any) => {
      return <TextCell>{value == 1 ? 'Yes' : 'No'}</TextCell>;
    }
  }
];

export const SubPOItemColumnDef = () => [
  {
    title: 'PO #',
    dataIndex: 'poNo',
    width: '20%',
    render: (value) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'PO Qty',
    dataIndex: 'orderQty',
    width: '20%',
    render: (value) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'PO # of Cartons',
    dataIndex: 'cartonsNo',
    width: '20%',
    render: (value) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Customer Name',
    dataIndex: 'clientName',
    width: '20%',
    render: (value) => {
      return <TextCell>{value}</TextCell>;
    }
  },
  {
    title: 'Customer PO#',
    dataIndex: 'clientPONo',
    width: '20%',
    render: (value) => {
      return <TextCell>{value}</TextCell>;
    }
  }
];
